(ns ncr.manage.accounts
  (:require
   [cljs.core.async :as async :refer-macros [go]]
   [clojure.string :as str]
   [com.rpl.specter :as s]
   [lambdaisland.glogi :as log]
   [uix.core.alpha :as uix]
   [tick.core :as t]
   [ncr.etc.util :as u]
   [ncr.etc.alert :as a]
   [ncr.amplitude :as amp]
   [ncr.backend :as b]
   [ncr.widgets.core :as w]
   [ncr.widgets.pf :as wpf]
   [ncr.etc.modal :as m]
   [ncr.etc.pf :as pf]
   [ncr.etc.pubsub :as ps]
   [ncr.etc.rhf :as rhf]
   [ncr.navigate :as n]))

(defn- c-account-dialog [{:keys [mode model]}]
  (let
    [{:keys [register-pf] :as form}
     (rhf/use-form {:shouldFocusError false :default-values model})

     ref (uix/ref)
     modal-id :new-account-modal]

    (m/use-submit-form modal-id ref (rhf/modal-submit form))

    [m/c-modal
     {:title (get {:update "Update Membership" :invite "Invite Account"} mode)
      :variant :small
      :is-overflow-visible true
      :id modal-id
      :ref ref
      :actions
      [[pf/c-button
        {:variant :primary
         :on-click (rhf/modal-submit form)}
        "Ok"]

       [pf/c-button
        {:variant :link
         :on-click #(m/close! nil)}
        "Cancel"]]}
     [pf/c-form {}
      (let [id (uix/memo #(gensym) [])]
        [rhf/c-form-group {:label "Email" :field-id id} :email form
         [pf/c-text-input
          (merge
            (register-pf :email
              {:required true
               :validate u/email?})
            {:id id
             :is-read-only (= mode :update)})]])

      (when (and (not (get model :is-owner)) (= mode :update))
        [rhf/c-form-group {:label "Status" :is-inline true} :xxxx form
         [wpf/c-pf-checkbox
          {:name :is-active :form form :label "Active"}]])

      [rhf/c-form-group {:label "Roles" :is-inline true} :xxxx form
       [:<>
        [wpf/c-pf-checkbox
         {:name :is-administrator :form form :label "Administrator"}]
        [wpf/c-pf-checkbox
         {:name :is-manager :form form :label "Manager"}]
        [wpf/c-pf-checkbox
         {:name :is-owner :form form :label "Owner" :is-disabled true}]]]]]))

(def role-map
  {:is-administrator :administrator :is-manager :manager :is-owner :owner})

(defn- roles-coll [model]
  (reduce
    (fn [acc [k v]]
      (if (get model k)
        (conj acc (name v))
        acc))
    [] role-map))

(defn- !update-account [account]
  (go
    (u/error-m
      [model
       (or
         (<!
           (m/!modal #'c-account-dialog
             {:mode :update
              :model
              (reduce
                (let [has-role? #(-> (get account :roles) (contains? %) boolean)]
                  (fn [acc [k v]]
                    (assoc acc k (has-role? v))))
                {:email (get account :email)
                 :is-active (get account :active)}
                role-map)}))
         [:error :cancel])
       _
       (<!
         (a/!operation {:operation-title "Update Membership" :success-title "Membership Updated" :body (get account :email)}
           (b/!mutation
             [:account_update_membership
              {:id (get account :id)
               :active (get model :is-active)
               :roles (roles-coll model)}])))]
      (ps/pub! [:accounts/load false]))))

(defn- !invite-account []
  (go
    (u/error-m
      [model
       (or
         (<!
           (m/!modal #'c-account-dialog
             {:mode :invite
              :model
              (s/setval [s/MAP-VALS] false role-map)}))
         [:error :cancel])
       _
       (<!
         (let [{:keys [email]} model]
           (a/!operation {:operation-title "Invite Account" :success-title "Account Invited" :body email}
             (b/!mutation
               [:account_invite
                {:email email
                 :roles
                 (roles-coll model)}]))))]
      (ps/pub! [:accounts/load false]))))

(defn- c-account [_ {:keys [email roles access_last active] account-name :name :as account}]
  [pf/c-data-list-item
   {:class :pf-m-selectable
    :on-click #(!update-account account)}
   [pf/c-data-list-item-row
    [pf/c-data-list-item-cells {:width 3}
     [pf/c-data-list-cell
      [pf/l-flex {:direction :column :space-items :space-items-xs}
       [:span account-name]
       [:span.pf-u-color-200 email]]]

     [pf/c-data-list-cell {:width 2}
      [:span.pf-u-primary-color-100
       (->> roles (map name) (sort) (interpose ", ") (apply str))]]

     [pf/c-data-list-cell {:width 1}
      [pf/l-flex {:direction :column :space-items :space-items-xs}

       (if active
         [:span.pf-u-primary-color-100 "ACTIVE"]
         [:span.pf-u-danger-color-100 "DEACTIVATED"])

       [:span.pf-u-color-100
        [w/c-date-distance access_last]]]]]

    [pf/c-data-list-action {}
     [pf/c-dropdown-menu
      {:dropdown-items
       [[pf/c-dropdown-item
         {:icon [w/c-menu-icon {:icon :account-edit-outline}]
          :on-click #(!update-account account)}
         "Edit"]]}]]]])

(defn- c-toolbar [_]
  (let []
    [pf/c-toolbar
     [pf/c-toolbar-content
      [pf/c-toolbar-group {:variant :icon-button-group}
       [w/c-toolbar-button
        {:icon :arrow-left
         :on-click
         (fn []
           (amp/navigate! {"Origin" "Manage Accounts" "Destination" "<back>"})
           (n/back!))
         :tooltip "Back"}]

       [w/c-toolbar-button
        {:icon :reload
         :on-click #(ps/pub! [:accounts/load true])
         :tooltip "Reload"}]]

      [pf/c-toolbar-group {:variant :icon-button-group}
       [w/c-toolbar-button
        {:icon :plus
         :on-click
         #(!invite-account)
         :tooltip "Invite"}]]]]))

(defn c-manage-accounts []
  (let
    [state
     (ps/sub-reducer-map! {}
       {::state
        (fn [_ state]
          state)

        :accounts/load
        (fn [state progress?]
          (go
            (u/when-fail
              [error
               (u/error-m
                 [accounts
                  (<!
                    (b/!query
                      [:account_enumerate
                       [:id :name :email :roles :access_last :active]]))

                  accounts
                  (->> accounts
                    (s/transform
                      [s/ALL :roles (s/transformed s/ALL keyword)] set)

                    (s/transform
                      [s/ALL :access_last] b/parse-utc-date-time))]

                 (ps/pub! [::state {:status :loaded :data {:accounts accounts}}]))]

              (do
                (ps/pub! [::state {:status :error :reason error}])
                (log/error :error error))))
          (if progress?
            {:status :progress
             :data (:data state)}
            state))})]

    (uix/with-effect []
      (ps/pub! [:accounts/load true]))

    [:<>
     [pf/c-page-section
      {:class :pf-u-p-0
       :variant :light
       :sticky :top
       :aria-label "Toolbar"}
      [c-toolbar {}]]

     [pf/c-page-section
      {:class :pf-u-p-0
       :variant :default
       :has-overflow-scroll true
       :is-filled true
       :aria-label "Accounts list"}
      (let [{:keys [reason status] {:keys [accounts]} :data} @state]
        (cond
          reason
          [w/c-inline-error {:message (str reason)}]

          (sequential? accounts)
          [pf/c-data-list {:is-compact true}
           (for [{:keys [id] :as account}
                 (sort-by
                   (juxt
                     (fn [{:keys [name]}]
                       (if (str/blank? name)
                         "zzzzzzzzzzzzzzzzzz"
                         name))
                     :email) accounts)]
             ^{:key id} [c-account {} account])]

          (= :progress status)
          [w/c-empty-progress "Loading..."]

          :else
          nil))]]))
